"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerHostedLivestreamStreamingPartnerProperty = exports.partnerHostedLivestreamStreamingPartnerPropertyDefinition = void 0;
exports.partnerHostedLivestreamStreamingPartnerPropertyDefinition = {
    view: { label: 'Partner' },
    constraints: [
        {
            name: 'stencils',
            argument: ['partner-profile'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'partner-hosted-livestream-streaming-partner',
};
const isPartnerHostedLivestreamStreamingPartnerProperty = (prop) => {
    return prop.name === exports.partnerHostedLivestreamStreamingPartnerPropertyDefinition.name;
};
exports.isPartnerHostedLivestreamStreamingPartnerProperty = isPartnerHostedLivestreamStreamingPartnerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1zdHJlYW1pbmctcGFydG5lci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BhcnRuZXItaG9zdGVkLWxpdmVzdHJlYW0tc3RyZWFtaW5nLXBhcnRuZXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx5REFBeUQsR0FBRztJQUN2RSxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFO0lBQzFCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsaUJBQWlCLENBQUM7U0FDOUI7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsNkNBQTZDO0NBQ3BCLENBQUE7QUFJMUIsTUFBTSxpREFBaUQsR0FBRyxDQUFDLElBQWtCLEVBQTJELEVBQUU7SUFDL0ksT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGlFQUF5RCxDQUFDLElBQUksQ0FBQTtBQUNyRixDQUFDLENBQUE7QUFGWSxRQUFBLGlEQUFpRCxxREFFN0QifQ==